var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandlebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1090 1090",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1046 493 C 1045 496 1043 497 1040 498 999 502 959 507 918 512 873 517 827 522 782 528 769 529 757 535 748 545 739 554 731 564 723 575 710 591 699 607 686 623 672 638 655 648 633 649 606 649 578 649 550 649 517 649 483 649 450 649 427 648 407 642 390 627 383 620 377 613 372 605 360 589 348 572 337 556 324 538 307 529 287 527 233 520 180 513 125 506 100 503 74 500 49 497 46 497 44 496 44 493 40 477 40 462 48 448 52 441 52 441 60 442 110 450 162 457 213 464 240 468 267 472 294 476 312 478 328 485 341 497 348 503 354 511 360 518 374 537 388 556 403 575 414 588 429 594 446 595 467 596 487 595 507 596 528 596 548 596 569 596 585 597 602 596 619 597 633 598 644 593 655 585 667 576 676 564 685 551 693 539 702 527 711 515 729 492 753 479 782 475 807 472 832 468 857 465 904 458 952 452 999 445 1010 444 1022 443 1033 441 1035 441 1037 442 1039 444 1046 454 1048 465 1049 477 1048 482 1047 487 1046 493 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandlebar);
export default __webpack_public_path__ + "static/media/handlebar.0ab82102eb8cca3a1cd30bb227b24ab0.svg";
export { ForwardRef as ReactComponent };